<template>
  <div class="d-flex align-items-center min-vh-100" v-if="message == 'success'">
    <CContainer fluid>

      <CRow class="justify-content-center" style="margin-top:100px">
        <CCol sm="5" lg="8">
          <CCol sm="5" lg="12">
              <CForm>
                
                <CCard>
                <img  v-bind:src="data.bgimage"  >
              
                  <CRow class="mt-5">
                    <CCol class="ml-5">
                  <h1>{{ data.name }}</h1>
                  <!-- <h4 class="mt-3">  {{ data.category  }}   {{'event'}}  </h4> -->
                 </CCol>  
                  </CRow>
                  <CRow class="mt-2">
                    <CCol>
                      <hr class="col-11">
                    </CCol>
                  </CRow>
                  <CRow class="mb-4 mt-3" >
                    <CCol class=" ml-5">
                  <h4>Date and Time </h4>
                  {{ format_date(data.datetime_event) }}
                    </CCol>
                    <CCol class="ml-5">
                      
                  <h4>Location </h4>
                  {{ data.location }}
                    </CCol>
                  </CRow> 
                </CCard>
                 
              </CForm>
          </CCol>
        </CCol>
      </CRow>

      
      <CRow class="justify-content-center" >
        <CCol sm="5" lg="8">
          <CCol sm="5" lg="12">
            <CCard>
      <CCardBody >
        <CTabs fill variant="pills">
          <CTab title="DESKRIPSI EVENT" active>
            <hr>
            <CRow class="mt-4">
              <CCol sm="5" md="12">
      <pre style="white-space: pre-wrap;font-family:verdana; word-break: keep-all;" class="text-muted">{{ data.description }}</pre>
              </CCol>
            </CRow>
          </CTab>
          <CTab title="REGISTRASI EVENT" >
            <hr>
            <CRow class="justify-content-center" style="margin-top:20px">
        <CCol sm="5" lg="12">
          <CCol sm="5" lg="12">
              <CForm>
                
                <!-- <p class="text-muted">Join Our Event</p> -->
                <CRow class="mt-4">
                  <CCol sm="5" lg="12" >
                  <label>Nama</label>
                  
                  <CInput placeholder="" autocomplete="name" v-model="form.name" required></CInput>
                  <label>Alamat</label>
                  <CInput placeholder="" autocomplete="address" v-model="form.address"></CInput>
                  <label>No. Tlp</label>
                  <CInput placeholder="" autocomplete="mobile_phone" v-model="form.mobile_phone"></CInput>
                  <label>Email</label>
                  <CInput placeholder="" autocomplete="email" v-model="form.email"></CInput> 
                  </CCol>
                  <CCol >                 
                  <label class="mt-2"><b>Additional Field</b></label>
                  <div v-for="(f, index) in form.form_field" :key="index">
                      <label>{{ f.label }}</label>

                    <div v-if="f.type == 'Text'">
                      <b-input placeholder="" autocomplete="" v-model="f.value" :id="'F' + index" :class="errors.firstname ? 'is-invalid' : ''"></b-input>
                      <b-form-invalid-feedback>
                        required
                      </b-form-invalid-feedback>
                    </div>

                    <div v-else-if="f.type == 'Radio'">
                      <!-- <input type="radio" :value="option" v-model="form.form_field[index].value">
                      <label>{{option}}</label> -->

                      <b-form-group v-slot="{ ariaDescribedby }" :class="errors.firstname ? 'is-invalid' : ''" :id="'F' + index">
                        <b-form-radio-group v-model="form.form_field[index].value" :aria-describedby="ariaDescribedby">
                        <b-form-radio v-for="option,k in f.detail" :key="k" :aria-describedby="ariaDescribedby" name="e" :value="option">{{ option }}</b-form-radio>
                        <!-- <b-form-radio :aria-describedby="ariaDescribedby" name="e" value="paid">Paid</b-form-radio> -->
                        </b-form-radio-group>
                      </b-form-group>     
                      <b-form-invalid-feedback>
                        required
                      </b-form-invalid-feedback>
                    </div>

                    <div v-else-if="f.type == 'Checkbox'">
                      <b-form-checkbox-group v-model="form.form_field[index].value" :id="'F' + index">
                        <b-form-checkbox v-for="option,k in f.detail" :key="k" :value="option">{{ option }}</b-form-checkbox>
                      </b-form-checkbox-group>
                      <b-form-invalid-feedback>
                        required
                      </b-form-invalid-feedback>
                    </div>

                  </div>
                  </CCol>
                </CRow>
              </CForm>
          </CCol>
        </CCol>
      </CRow>

      <CRow class="justify-content-center" style="margin-top:30px">
        <CCol md="12">
          <CCol md="12">
              <CForm>
                <h3>Tickets</h3>
                <p class="text-muted">Choose your tickets</p>
                  <div class="panel-body" id="app">
                      <table class="table table-hover">
                          <thead>
                          <tr>
                              <th style="width: 10px;">No.</th>
                              <th>Name</th>
                              <th>Description</th>
                              <th v-if="data.admission_fee == 'paid'">Price</th>
                              <th>Qty</th>
                              <th v-if="data.admission_fee == 'paid'">Total</th>
                              <th>Ticket Remaining</th>
                          </tr>
                          </thead>
                          <tbody v-sortable.tr="rows">
                      
                          <tr v-for="(arr, index) in form.custom_tickets" :key="index">
                              <td>
                                  {{ index + 1 }}
                              </td>
                              <td>
                                  {{ arr.name }}
                              </td>
                              <td>
                                  {{ arr.description }}
                              </td>
                              <td v-if="data.admission_fee == 'paid'">
                                  {{ arr.price }}
                              </td>
                              <td>
                                  <!-- <input class="form-control" v-model="arr.qty" number/> -->
                                  <CInput
                                    type="number"
                                    label=""
                                    :invalid-feedback="messageInvalidFeedback(arr.max)"
                                    v-model="arr.qty"
                                    min="0"                         
                                    :is-valid="validatorTicket(arr.qty,arr.max)"
                                  />
                              </td>
                              <td v-if="data.admission_fee == 'paid'">
                                  {{ subtotalRow[index] }}
                              </td>
                              <td>
                                {{ arr.quota_now }} Ticket
                              </td>
                          </tr>
                          </tbody>
                      </table>
                  </div>
                  <div v-if="data.admission_fee == 'paid'">
                    Grand Total: {{total}} 
                  </div>
              </CForm>
          </CCol>  
        </CCol>
      </CRow>
      <CRow class="justify-content-center" style="margin-top:30px" v-if="data.admission_fee == 'paid'">
        <CCol md="12">
          <CCol md="12">
              <CForm>
                <h3>Payment Information</h3>
                <p class="text-muted">please pay on the following account</p>
                  <div v-for="(f, index) in payment_information" :key="index">
                            <label>{{ f.bank }}  {{ " " }}  {{ f.account }}</label>
                  </div>                
              </CForm>
          </CCol>  
        </CCol>
      </CRow>
          <CRow class="justify-content-center" style="margin-top:20px;margin-bottom:20px">
        <CCol md="12">
          <CCol md="12">
              <CForm>
                <CRow class="justify-content-center">
                  <vue-recaptcha sitekey="6Lc2l4AaAAAAAOn_1u80OFkISECjsTt4NJl-jpPw" :loadRecaptchaScript="true" @verify="onVerify"></vue-recaptcha>
                </CRow>
                <CRow v-if="!loading_submit" class="justify-content-center">
                  <CButton class="mt-2" style="width:300px" color="success" block v-on:click.prevent="create()" type="submit" :disabled=!captcha>Submit</CButton>
                  <!-- <CButton style="width:200px" color="success" block v-on:click.prevent="create()" type="submit" :disabled=submitted>Create Account</CButton> -->
                  <!-- <CButton style="width:200px" color="success" block v-on:click.prevent="create()" type="submit" >Create Account</CButton> -->
                </CRow>
                <CRow v-else class="justify-content-center">
                  <b-spinner variant="primary" label="Spinning"><br></b-spinner>
                </CRow>
              </CForm>            
          </CCol>
        </CCol>
      </CRow> 
          </CTab>  
        </CTabs>
      </CCardBody>
            </CCard>
          </CCol>
        </CCol>
      </CRow>
<!-- <pre>{{ $data | json }}</pre> -->
    </CContainer>
  </div>
<div class="d-flex align-items-center min-vh-100"  v-else-if="response_message">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm>
                <h1>{{ response_message }}</h1>
                <p class="text-muted">Please check your email</p>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
</div>
<div class="d-flex align-items-center min-vh-100"  v-else>
<alertmodal></alertmodal>
</div>
</template>
<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import axios from 'axios';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';

import event from '@/services/event';

import VueRecaptcha from 'vue-recaptcha';

import moment from 'moment'

export default {
components: { VueRecaptcha,alertmodal },
// metaInfo: {
//   title: 'Default App Title',
//   titleTemplate: '%s | vue-meta Example App',
//   htmlAttrs: {
//     lang: 'en-US'
//   },
//   meta: [
//       { name: 'description', content:  'meta description'},
//       { property: 'og:title', content: "meta og title"},
//       { property: 'og:site_name', content: 'meta site name'},
//       {property: 'og:type', content: 'website'},    
//       {name: 'robots', content: 'index,follow'} 
//   ]
// },
    data(){
        return{
          errors:{},
          form:{
              event_id:'',
              name:'',
              adrress:'',
              email:'',
              phone:'',
              mobile_phone:'',
              total:'',
              form_field:[],
              custom_tickets:[],
              admission_fee:''
          },
          data:[],
          eventID:'',
          eventName:'',
          message:'',
          response_message:'',
          captcha: false,
          payment_information:[],
          // isValid: false,
          loading_submit: false
        }
    },
    mounted() {
      this.loadData()
    },
    computed: {
        subtotalRow() {
          return this.form.custom_tickets.map((arr) => {
            return arr.total = Number(arr.qty * arr.price) || 0
          });
        },
        total(){
          return this.form.custom_tickets.reduce((total, item) => {
            //return this.form.total = total + item.total;
            return this.form.total = total + item.qty * item.price;
          }, 0);
        },
        // submitted: function(){
        //   if(!this.isValid) {
        //     return true;
        //   }else{
        //     return false;
        //   }
        // }
    },
    methods: {
      loadData(){
        event.getEventRegistrationPage(this.$route.query.id)
        .then(res => {
          this.message = res.message
          this.data = res.data
          this.eventName = res.data.name
          this.eventID = res.data.id
          this.form.event_id = res.data.id
          this.form.form_field = JSON.parse(res.data.form_field);
          this.payment_information = JSON.parse(res.data.payment_information)
          this.form.custom_tickets = res.data.event_tickets;
          //this.form.custom_tickets = JSON.parse('{"foregrounds" : foregrounds,"backgrounds" : backgrounds}');
          this.form.admission_fee = res.data.admission_fee;
        })  
      },   
      create(){
        var cc = true;
        for (let i=0; i <= this.form.form_field.length-1; i++){
          if (this.form.form_field[i].required == "1") {
            if (!this.form.form_field[i].value || this.form.form_field[i].value.length == 0) {
              var someElement= document.getElementById("F"+i);
              someElement.className += " is-invalid";  
              cc = false;   
            }else{
              var someElement= document.getElementById("F"+i);
              someElement.className -= " is-invalid";  
            }
          }
        }

        if (cc){
          this.loading_submit = true
          event.createEventRegistration(this.$route.query.id, this.form)
          .then(res => {
              // console.log(res.message)
              // alert(res.message)
              this.response_message = res.message
              this.message = 'false'
              // var params = {title: 'Success', mode:'success', data:res.message}
              // EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
              console.log(err.response.data.message)
              alert(err.response.data.message)
              this.loading_submit = false
              // var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              // EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
        }

      },
      onVerify: function (response) {
        if (response) this.captcha = true;
      },
      validatorTicket: function(val,max) {
        if(val >= 0 && val <= max){
          return null;
        }else{
          return false;
        }
        //return val ? (val >= 0 && val <= max) : false
      },
      messageInvalidFeedback: function(max) {
        return "Maksimal " + max + " tiket"
      },

      format_date(value){
         if (value) {
           return moment(String(value)).format('LLLL')
          }
      },

    }
}
</script>
